import useAppQuery from 'core/query-client/useAppQuery';
import { getSpaces } from 'shared/api/spaces/http';

const useSpacesQuery = () =>
  useAppQuery('spaces', getSpaces, {
    cacheTime: Infinity,
    refetchOnMount: false
  });

export default useSpacesQuery;
